import React, { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { helperConstants as constants } from "../../helpers/helperConstants";
import { normalizeEther } from "../../helpers/digits";
import { closeModal } from "../../redux/counterSlice";
import { ChainIcon } from "../Icon";
import { getTokenName } from "../../helpers/getChainName";
import { ModalContainer } from "./modalContainer";
import { ModalItemDetails } from "./modalComponents/modalItemDetails";
import useGetTokenPrice from "../../services/useGetTokenPrice";
import rejectLendOfferByOfferID from "../../services/rejectLendOfferByOfferID";

const MODAL_KEY = "RejectModal";
const RejectModal = () => {
  const dispatch = useDispatch();
  const { modal } = useSelector((state: any) => state.counter);
  const [buttonText, setButtonText] = useState("Reject");
  const [buttonLoading, setButtonLoading] = useState(false);
  const { item, collection, refresh, ...offer } = modal?.data;

  const { usdPrice: tokenPrice, currentChainId } = useGetTokenPrice(item?.chain);

  const onReject = async (id: any) => {
    try {
      setButtonLoading(true);
      setButtonText("Rejecting the offer...");
      const res = await rejectLendOfferByOfferID({ id: id });
      if (res?.status === "success") {
        toast.success("Offer rejected successfully");
        refresh && refresh();
        dispatch(closeModal());
      } else {
        toast.error(res?.data?.message ?? "Something went wrong");
      }
    } catch (err) {
      toast.error(err.reason ? err.reason : "err:" + err);
      //   console.log(error);
    } finally {
      setButtonLoading(false);
      setButtonText("Reject");
    }
  };

  const isGlobal = modal?.data?.isGlobal;
  const image = item?.imageFtpPath
    ? constants.cdn.path + item?.imageFtpPath + constants.cdn.thumbnail + constants.cdn.version
    : item?.metadata?.image
    ? item?.metadata?.image
    : constants.helpers.noImage;
  const thumbnail =
    modal?.data?.itemId && modal?.data?.other?.metadata?.name.indexOf("Moon") === -1
      ? `https://moonpets.com/api/nftThumbnailimage/${modal?.data?.itemId}`
      : image;

  // const bnbPrice = useGetUSDPriceOfToken('wbnb', item?.price)?.data?.wbnb?.usd;
  // const order = useGetOrder(
  //   modal?.data?.signature,
  //   modal?.data?.kind,
  //   modal?.data?.chain,
  // ).data;
  // const order = useGetOrder(signature, kind, chain)?.data;

  return (
    <ModalContainer modalKey={MODAL_KEY} title={`Reject ${isGlobal ? "Global" : ""} Offer`}>
      {/* <Toaster position='top-right' /> */}

      {/* <!-- Body --> */}
      <div className="modal-body p-6">
        {/* {!isGlobal && ( */}
        <ModalItemDetails item={item} collection={collection} isGlobal={offer?.isGlobal} />
        {/* )} */}
        <div className="relative flex border-jacarta-100 pb-4 dark:border-jacarta-600">
          <div className="mt-2 w-full">
            <div className="flex w-full">
              <div className="">Current Listing Price:</div>
              <div className="ml-auto flex w-fit space-x-1">
                <span className="ml-auto flex items-center whitespace-nowrap">
                  <div className="hidden pt-0.5"></div>
                  <ChainIcon
                    width={14}
                    name={item?.chain}
                    tooltip={getTokenName(item?.chain)}
                    // sideGap={true}
                    pt={0.5}
                  />
                  <span className="text-sm font-medium tracking-tight dark:text-jacarta-100">
                    {normalizeEther(offer?.borrowAmount)}
                  </span>
                </span>
                <div className="mt-1 text-sm dark:text-jacarta-300">
                  ~ ${normalizeEther(tokenPrice * normalizeEther(offer?.borrowAmount))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Terms --> */}
      </div>
      {/* <!-- end body --> */}

      <div className="modal-footer">
        <div className="flex items-center justify-center space-x-4">
          {
            /*  modal?.data?.chain !== currentChainId ? (
              <button
                type="button"
                className="rounded-xl bg-accent py-3 px-8 text-center font-semibold text-white transition-all hover:bg-accent-dark"
                onClick={() => switchNetwork(modal?.data?.chain)}
              >
                Switch to{" "}
                {
                  supportedChains.find((c) => c.hexId === modal?.data?.chain)
                    ?.name
                }
              </button>
            ) : */ <button
              type="button"
              className={`${
                (buttonText !== "Reject" || buttonLoading) && "opacity-40"
              } rounded-xl bg-accent py-3 px-8 text-center font-semibold text-white transition-all hover:bg-accent-dark`}
              onClick={onReject.bind(this, offer?.id)}
              disabled={buttonText !== "Reject" || buttonLoading}
            >
              {buttonText}
            </button>
          }
        </div>
      </div>
    </ModalContainer>
  );
};

export default RejectModal;
